<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '../../../types/site'

defineProps<{ block: SiteBlock }>()

const t = useSiteEditorT()

const ALIGNMENTS = [
  { value: 'center', label: t('site.f.hero.opt_center', 'Center') },
  { value: 'left', label: t('site.f.hero.opt_left', 'Left') }
] as const

const ANIMATIONS = [
  { label: t('site.f.hero.opt_none', 'None'), value: 'none' },
  { label: t('site.f.hero.opt_particles', 'Particles'), value: 'particles' },
  { label: t('site.f.hero.opt_orbit_rings', 'Orbit rings'), value: 'orbit_rings' },
  { label: t('site.f.hero.opt_aurora', 'Aurora'), value: 'aurora' },
  { label: t('site.f.hero.opt_dot_grid', 'Dot grid'), value: 'dot_grid' },
  { label: t('site.f.hero.opt_shooting_stars', 'Shooting stars'), value: 'shooting_stars' }
]
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField :label="t('site.f.hero.eyebrow', 'Eyebrow (optional)')">
    <UInput
      v-model="block.data.eyebrow"
      class="w-full"
    />
  </UFormField>
  <UFormField :label="t('site.f.common.headline_label', 'Headline')">
    <UInput
      v-model="block.data.headline"
      class="w-full"
    />
  </UFormField>
  <UFormField :label="t('site.f.hero.sub_text', 'Sub text')">
    <UTextarea
      v-model="block.data.subtext"
      :rows="2"
      class="w-full"
    />
  </UFormField>
  <div class="grid grid-cols-2 gap-2">
    <UFormField :label="t('site.f.common.button_text', 'Button text')">
      <UInput
        v-model="block.data.button_text"
        class="w-full"
      />
    </UFormField>
    <UFormField
      :label="t('site.f.common.button_url_label', 'Button URL')"
      :help="t('site.f.hero.the_button_is_hidden_unless_both_text_an_help', 'The button is hidden unless both text and a URL are set.')"
    >
      <UInput
        v-model="block.data.button_url"
        class="w-full"
      />
    </UFormField>
  </div>
  <UFormField :label="t('site.f.hero.background_image', 'Background image (optional)')">
    <SiteEditorImagePicker
      variant="wide"
      :model-value="block.data.image"
      @update:model-value="block.data.image = $event"
    />
  </UFormField>
  <UFormField :label="t('site.f.hero.alignment', 'Alignment')">
    <SiteEditorOptionToggle
      :options="ALIGNMENTS"
      :model-value="block.data.align ?? 'center'"
      @update:model-value="block.data.align = $event as 'left' | 'center'"
    />
  </UFormField>
  <UFormField
    v-if="block.data.image"
    :label="t('site.f.hero.darken_image_for_readability', 'Darken image for readability')"
  >
    <USwitch v-model="block.data.overlay" />
  </UFormField>
  <UFormField
    v-if="!block.data.image"
    :label="t('site.f.hero.background_animation', 'Background animation')"
    :help="t('site.f.hero.only_shown_without_a_background_image_help', 'Only shown without a background image.')"
  >
    <USelect
      :model-value="block.data.animation ?? 'none'"
      :items="ANIMATIONS"
      class="w-full"
      @update:model-value="block.data.animation = $event"
    />
  </UFormField>
</template>
